export Form from './Form';



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/propertyGroup/components/index.js